export enum SoilingRiskAssessment {
  LOW = 'LOW',
  HIGH = 'HIGH',
  UNDEFINED = '-',
}

export type ReportPackageStatus = 'up_to_date' | 'stale' | 'missing';

export type ReportPackageKey = 'assessment' | 'mitigation' | 'operational' | 'ex_post';

export type SolutionPackageKey = Exclude<ReportPackageKey, 'assessment'>;

export type SolutionChartKey =
  | 'npv_heatmap'
  | 'production'
  | 'soiling_ratio'
  | 'capex'
  | 'opex'
  | 'financial_comparison'
  | 'production_losses'
  | 'cleaning_schedules';

/** Chart identifiers of the server report catalogue, `<package>.<chart>`. */
export type ReportChartId = 'assessment.soiling_risk' | 'assessment.soiling_ratio' | `${SolutionPackageKey}.${SolutionChartKey}`;
